import { DeviceLogDto, DeviceLogListMetaDataDto, DeviceLogClient } from '@/apiClients';
import authorizedClient from './authorizedClient';

export interface IDeviceLogState {
  deviceLog: DeviceLogDto[];
  deviceLogMetaData: DeviceLogListMetaDataDto | null;
}

export interface IGetDeviceLogsPayload {
  deviceId: string;
  filter: string;
  pageOffset: number;
  pageSize: number;
}

export default {
  namespaced: true as true,
  state: () =>
    ({
      deviceLog: [], 
      deviceLogMetaData: null, 
    }) as IDeviceLogState,

  getters: {
    deviceLog: (state: IDeviceLogState) => () => state.deviceLog,
    deviceLogMetaData: (state: IDeviceLogState) => () => state.deviceLogMetaData, 
  },
  mutations: {
    SET_DEVICELOGS(state: IDeviceLogState, deviceLog: DeviceLogDto[]) {
      state.deviceLog = deviceLog;
    },
    SET_DEVICELOGS_METADATA(state: IDeviceLogState, deviceLogMetaData: DeviceLogListMetaDataDto) {
      state.deviceLogMetaData = deviceLogMetaData;
    },
    CLEAR_DEVICELOGS(state: IDeviceLogState) {
      state.deviceLog = []; // Clear the array
    },
  },
  actions: {
    async getDeviceLogs({ commit }: any, payload: IGetDeviceLogsPayload) {
      const deviceLogClient = await authorizedClient(DeviceLogClient);
      try {
        const deviceLogList = await deviceLogClient.getAllLogFiles(
          payload.deviceId,
          payload.filter,
          payload.pageOffset,
          payload.pageSize,
          process.env.VUE_APP_TERMINAL_WEB_API_VERSION
        );
        if (deviceLogList) {
          commit('SET_DEVICELOGS', deviceLogList.deviceLogs);
          commit('SET_DEVICELOGS_METADATA', deviceLogList.metaData);
          return deviceLogList;
        }
      } catch (error) {
        throw error;
      }
      return [];
    },
  },
};

